const arrayMove = (array: any, oldIndex: number) => {
  array.unshift(array.splice(oldIndex, 1)[0]);
  return array;
};

export { arrayMove };
